import { ReactNode } from 'react';
import { Rule } from 'antd/es/form';
import { AppFormItemProps } from 'components/atoms/Form/AppFormItem/AppFormItem';
import { AppFormRangeItem } from 'components/atoms/Form/AppFormRangeItem/AppFormRangeItem';
import { AppFormRangeItemMode } from 'types';
import { commonTexts } from 'consts/text';
import { datesTimelineValidator } from 'utils/validators';
import { FormItemData, timePickerData, datePickerData } from './DurationDateTimeFormItemBase.utils';

export type DurationDateTimeFormItemBaseProps = AppFormItemProps & {
    pickerType: 'date' | 'time';
    rangeItemMode: AppFormRangeItemMode;
    startFormItemData: FormItemData;
    finishFormItemData: FormItemData;
    isFinishValueBeforeStartValueErrorText: string;
    isStartValueAfterFinishValueErrorText: string;
    picker: ReactNode;
};

export const DurationDateTimeFormItemBase = ({
    pickerType,
    rangeItemMode,
    startFormItemData,
    finishFormItemData,
    isFinishValueBeforeStartValueErrorText = commonTexts.errorMessages
        .dateToBeforeDateFromErrorText,
    isStartValueAfterFinishValueErrorText = commonTexts.errorMessages.dateFromAfterDateToErrorText,
    picker,
    disabled,
    ...props
}: DurationDateTimeFormItemBaseProps) => {
    const { unitToCompare, dataFormatLabel } =
        pickerType === 'date' ? datePickerData : timePickerData;

    const rules: Rule[] = [
        ({ getFieldValue }) =>
            datesTimelineValidator(getFieldValue, {
                mode: rangeItemMode,
                startValueFieldName: startFormItemData.name,
                finishValueFieldName: finishFormItemData.name,
                isFinishValueBeforeStartValueErrorText,
                isStartValueAfterFinishValueErrorText,
                unitToCompare,
            }),
    ];

    return (
        <AppFormRangeItem
            mode={rangeItemMode}
            startValues={{
                label: startFormItemData.label,
                additionalText: dataFormatLabel,
                name: startFormItemData.name,
                rules,
                disabled: !!(rangeItemMode === 'start' && disabled),
            }}
            finishValues={{
                label: finishFormItemData.label,
                additionalText: dataFormatLabel,
                name: finishFormItemData.name,
                rules,
                disabled: !!(rangeItemMode === 'finish' && disabled),
            }}
            {...props}
        >
            {picker}
        </AppFormRangeItem>
    );
};
